import React, { useState } from 'react';
import type { AtlasCatalogItem } from '../../services/atlasService';
import AtlasSelectionCard from './AtlasSelectionCard';
import selectAtlasTemplates, { getAtlasFamily as familyOf, getAtlasFamilyTitle } from '../../utils/selectAtlasTemplates';

interface AtlasSelectionSectionsProps {
  atlases: AtlasCatalogItem[];
  selectedAtlasId: string | null;
  onSelect: (atlasId: string) => void;
  token?: string | null;
  selectionLocked?: boolean;
}

export default function AtlasSelectionSections(props: AtlasSelectionSectionsProps) {
  const selectedAtlas = props.atlases.find(atlas => atlas.id === props.selectedAtlasId);
  const [expandedFamily, setExpandedFamily] = useState<string | null>(() =>
    selectedAtlas ? familyOf(selectedAtlas) : 'MNI'
  );
  const families = Array.from(new Set(['MNI', 'PD25', 'PD126', ...props.atlases.map(familyOf)]));
  return (
    <div className="dicom-series-category-content pc-atlas-family-grid">
      {families.map(family => {
        const available = props.atlases.filter(atlas => familyOf(atlas) === family);
        const atlases = [...selectAtlasTemplates(available)];
        if (
          selectedAtlas &&
          familyOf(selectedAtlas) === family &&
          !atlases.some(atlas => atlas.id === selectedAtlas.id)
        ) {
          atlases.push(selectedAtlas);
        }
        return (
          <AtlasSelectionCard
            key={family}
            family={family}
            title={getAtlasFamilyTitle(family)}
            atlases={atlases}
            demoFamily={family === 'MNI' ? 'MNI' : family === 'PD126' ? 'PD126' : 'PD25'}
            selectedAtlasId={props.selectedAtlasId}
            expanded={expandedFamily === family}
            onToggle={() => setExpandedFamily(current => (current === family ? null : family))}
            onSelect={props.onSelect}
            selectionLocked={props.selectionLocked}
            token={props.token}
          />
        );
      })}
    </div>
  );
}
